import React from 'react';

import { noop } from 'lodash';

import { IAuthUser } from '~/context/AuthContext';
import IconButton from '~/core/atoms/Buttons/IconButton';

interface UserAvatarButtonProps {
  user: IAuthUser | null;
  onClick?: () => void;
}

const UserAvatarButton: React.FC<UserAvatarButtonProps> = ({ user, onClick = noop }) => {
  const userInitial = user?.name ? user.name.charAt(0).toUpperCase() : '';

  return (
    <IconButton
      onClick={onClick}
      aria-label="Toggle User Menu"
      round
      className="flex-1 bg-gradient-to-t from-teal-600 to-blue-600 text-xl text-white outline-none hover:to-blue-900"
    >
      {userInitial}
    </IconButton>
  );
};

export default UserAvatarButton;
